import Image from "next/image";
import React from "react";

import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { Document } from "@contentful/rich-text-types";
import { Box, Stack, Step, Typography } from "@mui/material";

import { styles } from "./styles";
import { RedeemPartnerStepsCardProps } from "./types";

export const RedeemPartnerStepsCard: React.FC<RedeemPartnerStepsCardProps> = ({ image, description }) => {
  return (
    <Stack
      css={styles.stack}
      sx={{
        height: "100%",
        display: "flex"
      }}
    >
      <Box css={styles.box} />
      <Step css={styles.step}>
        <Image src={image} alt="ícone" width={36} height={36} />
        <Typography component="div" css={styles.typography}>
          {documentToReactComponents(description as Document)}
        </Typography>
      </Step>
    </Stack>
  );
};
